import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV === 'development';

export const storeOptions = {
  modules: {},
  strict: debug
};

const store = new Vuex.Store(storeOptions);
export default store;
